import { validationResultsToPilotApiMetrics } from '../../../../api_services/PilotApiService';
import {
  CustomerId,
  FailedWorkerJob,
  PhotoValidationCompletedEventPayload,
  SiteId,
  ValidationResult,
} from '../../../../types';
import { UploadData } from '../../../../store/uploadStore';
import { mapUploadTypeToMetricsEntityType, MetricsEntity } from '../../../../libs/metrics/metricUtils';
import { Point } from '@influxdata/influxdb-client-browser';
import { influxWriter } from '../../../../libs/metrics/InfluxWriter';

export const sendValidationMetrics = (upload: UploadData, payload: PhotoValidationCompletedEventPayload) => {
  const { customer, site } = upload.upload!;
  const entityType = mapUploadTypeToMetricsEntityType(upload.meta.type);

  sendPhotoValidationFailures(customer, site, entityType, payload.failedValidations, 'ValidationFail');
  sendPhotoValidationFailures(customer, site, entityType, payload.failedJobs, 'WorkerJobFail');
  sendPhotoValidationMetrics(customer, site, entityType, payload.validations);
};

const sendPhotoValidationMetrics = (
  customerId: CustomerId,
  siteId: SiteId,
  entityType: MetricsEntity,
  validations: ValidationResult[],
) => {
  const pilotApiValidations = validationResultsToPilotApiMetrics(validations);

  Object.entries(pilotApiValidations).forEach(([validationName, [passed, metric]]) => {
    const point = new Point();
    point.tag('Customer', customerId);
    point.tag('Site', siteId);
    point.tag('EntityType', entityType);

    point.floatField('value', metric);
    point.floatField('passed', Number(passed));

    point.tag('Check', validationName);

    influxWriter.send('ValidationCheck', point);
  });
};

const sendPhotoValidationFailures = (
  customerId: CustomerId,
  siteId: SiteId,
  entityType: MetricsEntity,
  failures: FailedWorkerJob[],
  type: 'ValidationFail' | 'WorkerJobFail',
) => {
  failures.forEach(({ name }) => {
    const point = new Point();
    point.tag('Customer', customerId);
    point.tag('Site', siteId);
    point.tag('EntityType', entityType);

    point.floatField('value', 1);

    point.tag('Check', name);

    influxWriter.send(type, point);
  });
};
